<template>
  <v-row class="kbWhite  mx-0 mb-3" justify="center">
    <!-- Components   -->
    <SelectPicture
      @cropped="updateProfilePhoto($event)"
      v-model="showSelectPicture"
    />

    <ChangePassword v-model="showChangePassword"/>

    <CreateShortLink v-model="showCreateShortLinkDialog"/>

    <v-col cols="12">
      <span class="kbDarkBlueText--text text-h5 text-capitalize pl-3">
        {{ $t('sidebar.userConfiguration') }}
      </span>
    </v-col>

    <v-col cols="12">
      <v-divider />
    </v-col>

    <v-col
      class="d-flex flex-column align-center"
      cols="12"
      md="6"
      lg="4"
    >
      <div style="position: relative; display: inline-flex">
        <v-avatar class="elevation-4" size="200px">
          <template v-if="imageProfile">
            <v-img :src="imageProfile"
                   @error="onErrorImage()">
            </v-img>
          </template>

          <template v-else>
            <v-icon @click="showSelectPicture = true"
                    style="border: solid 1px rgba(0,0,0,.1)"
                    large>
              mdi-face
            </v-icon>
          </template>
        </v-avatar>

        <v-btn
          elevation="1"
          fab
          small
          style="position: absolute; bottom: 0; right: 20px"
        >
          <v-icon
            @click="showSelectPicture = true"
            x-small
          >
            mdi-camera
          </v-icon>
        </v-btn>
      </div>

      <v-list color="kbWhite" class="mt-3" width="100%">
        <v-list-item @click="openChat()" class="hidden-xl-only">
          <v-list-item-action>
            <v-icon color="kbDarkBlueText">mdi-face-agent</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="kbDarkBlueText--text">
              {{ $t('toolbar.support') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="openChangePasswordDialog()">
          <v-list-item-action>
            <v-icon color="kbDarkBlueText">lock</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="kbDarkBlueText--text">
              {{ $t('toolbar.changePassword') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="openCreateShortLinkDialog()">
          <v-list-item-action>
            <v-icon color="kbDarkBlueText">link</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="kbDarkBlueText--text">
              {{ $t('toolbar.shortenLink') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="logout()">
          <v-list-item-action>
            <v-icon color="kbDarkBlueText">
              exit_to_app
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="kbDarkBlueText--text">
              {{ $t('toolbar.exit') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-col>

    <v-col
      class="d-flex flex-column align-center time-zone-column px-md-6"
      :class="$vuetify.theme.isDark ? 'dark' : null"
      cols="12"
      md="6"
      lg="8"
    >
      <div style="min-width: 400px">
        <h6 class="kbDarkBlueText--text text-h6 d-block mb-2 font-weight-medium">
          {{ $t('general.pickTimeZone') }}
        </h6>
        <PickTimeZone
          background-color="kbLight"
          return-object
          v-model="userKeybeTimeZone"
        />
        <p class="mt-5 text-justify" style="max-width: 70%">
          {{ $t('general.timeZoneInformation') }}
        </p>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
import ChangePassword from '@/components/dialogs/ChangePassword.vue'
import CreateShortLink from '@/components/dialogs/CreateShortLink.vue'
import PickTimeZone from '@/pages/App/Sequences/widgets/Scheduler/PickTimeZone'
import SelectPicture from '@/pages/App/KeybeUi/SelectPicture.vue'
import UserKeybeExtraData from '@/mixins/UserKeybeExtraData'
export default {
  components: {
    ChangePassword,
    CreateShortLink,
    PickTimeZone,
    SelectPicture
  },
  computed: {
    ...mapState({
      userKeybe: state => state.auth.userKeybe
    }),
    imageProfile () {
      if (this.errorImageProfile) return ''
      return this.userKeybe.image || this.userKeybe.photo
    },
    userKeybeTimeZone: {
      get () {
        return this.$store.state.auth.userKeybeTimeZone
      },
      set (value) {
        this.$store.commit('SET_KEYBE_USER_TIME_ZONE', value)
        this.updateUserKeybeExtraData(this.userTimeZoneIndex, value, this.userTimeZoneField)
      }
    }
  },
  created () {
    this.setTimeZoneAndIndexTimeZone()
  },
  data () {
    return {
      errorImageProfile: false,
      showChangePassword: false,
      showCreateShortLinkDialog: false,
      showSelectPicture: false,
      userTimeZoneIndex: -1,
      userTimeZoneField: 'USER_TIME_ZONE'
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('logout')
    },
    onErrorImage () {
      this.errorImageProfile = true
    },
    openChangePasswordDialog () {
      this.showChangePassword = true
    },
    openChat () {
      window.keybe.openChat()
    },
    openCreateShortLinkDialog () {
      this.showCreateShortLinkDialog = true
    },
    async setTimeZoneAndIndexTimeZone () {
      const { index, foundExtraData } = this.findUserKeybeExtraData(this.userTimeZoneField)
      this.userTimeZoneIndex = index
      if (!foundExtraData) {
        this.userKeybeTimeZone = this.$store.state.auth.userKeybeTimeZone
        this.userTimeZoneIndex = this.userKeybeExtraData.length
      } else {
        this.userKeybeTimeZone = foundExtraData
      }
    },
    async updateProfilePhoto (image) {
      try {
        const data = {
          administratorId: this.userKeybe.userId,
          photo: image.url,
          userType: this.userKeybe.type
        }

        const response = await this.$store.dispatch('updateAdministrator', data)
        this.$store.commit('SET_KEYBE_USER', response.user)
        this.showSelectPicture = false
        notifications.success(this.$t('general.profilePicUpdated'))
      } catch (e) {
        notifications.error(e.message)
      }
    }
  },
  mixins: [UserKeybeExtraData]
}
</script>

<style scoped>
@media screen and (min-width: 960px) {
  .time-zone-column {
    border-left: 1px solid rgba(0, 0, 0, 0.12)!important;
  }
  .time-zone-column.dark {
    border-left: 1px solid rgba(255, 255, 255, 0.12)!important;
  }
}
</style>
